import React from 'react';
import { connect } from 'react-redux';
import { Icon } from '@amzn/storm-ui';
import { bellOutline } from '@amzn/storm-ui-icons';
import { RootState } from 'src/app/store';
import {
  CommunicationsDrawerInfo,
  selectCommunicationsDrawerInfo,
} from '../../store/slice';
import { UtilitiesIconButton } from '../styles';
import { ErrorBoundary } from 'src/commons/components/ErrorBoundary';
import { MobileCommuCommunicationsDrawerPublisher } from 'src/commons/utils/metrics';
import { communicationsDrawerTaktId } from './constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const COMMUNICATIONS_PATH = '/communications/feed?entityId=';

export const WrappedAcesCommunicationsDrawer: React.VFC<{
  communicationsDrawerInfo?: CommunicationsDrawerInfo;
}> = ({ communicationsDrawerInfo }) => {
  if (!communicationsDrawerInfo) {
    return null;
  }

  return (
    <ErrorBoundary name="aces-dynamic-communications-drawer-mobile">
      <UtilitiesIconButton
        onClick={() => {
          MobileCommuCommunicationsDrawerPublisher.publishCounterMonitor(
            'Open',
            1,
          );
          window.location.assign(
            `${COMMUNICATIONS_PATH}${communicationsDrawerInfo.texts.entityId}`,
          );
        }}
        aria-label={communicationsDrawerInfo.texts.label}
        {...getTaktAttributes(
          communicationsDrawerTaktId,
          chromeComponents.HEADER,
        )}
      >
        <Icon type={bellOutline} size="large" />
      </UtilitiesIconButton>
    </ErrorBoundary>
  );
};
const acesConnector = connect((state: RootState) => {
  return {
    communicationsDrawerInfo: selectCommunicationsDrawerInfo(state),
  };
});

export const ConnectedWrappedAcesCommunicationsDrawer = acesConnector(
  WrappedAcesCommunicationsDrawer,
);
